import fetchClient, { ApiResponse } from '../api-client'
import { CheckCouponPayload } from './types/CheckCouponPayload'
import { CheckCouponResponse } from './types/CheckCouponResponse'
import { CreatePaymentLinkPayload } from './types/CreatePaymentLinkPayload'
import { CreateRPPaymentLinkPayload } from './types/CreateRPPaymentLinkPayload'
import { TaxesData } from './types/TaxesData'

export const createPaymentLink = async (payload: CreatePaymentLinkPayload) => {
  const res = await fetchClient.post<ApiResponse<string>>('/payments/getlink', payload)
  return res.data.data
}

export const checkCoupon = async (payload: CheckCouponPayload): Promise<CheckCouponResponse> => {
  try {
    const res = await fetchClient.post<ApiResponse<CheckCouponResponse>>('/coupons/check', payload)
    return res.data.data
  } catch (error) {
    throw error
  }
}

export const getPkgTaxes = async (packageId: string) => {
  try {
    const reponse = await fetchClient.get<ApiResponse<{ response: TaxesData }>>(`/taxes/${packageId}`)
    // console.log("getPackageTaxes - reponse:", reponse)

    return reponse.data.data.response
  } catch (error) {
    console.log('getPackageTaxes - error:', error)
    throw error
  }
}

export const createPaymentLinkRP = async (payload: CreateRPPaymentLinkPayload): Promise<string> => {
  const res = await fetchClient.post<ApiResponse<string>>('/payments/getlink-returnPackage', payload)
  return res.data.data
}

export const TAX_FREE_THRESHOLD = 150
export const ID_REQUIRED_THRESHOLD = 150
